import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { VoicePicker } from "./VoicePicker";
import { BarsLabelInput } from "./BarsLabelInput";

// "Choose Voice" popup: two columns of voices with previews; Save applies the pick to this video.
export function VoiceDialog({ open, onOpenChange, voice, onSave, barsLabel, setBarsLabel }) {
  const [draft, setDraft] = useState(voice);
  const [labelDraft, setLabelDraft] = useState(barsLabel);
  useEffect(() => { if (open) { setDraft(voice); setLabelDraft(barsLabel); } }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="voice-dialog" className="max-w-2xl">
        <DialogHeader><DialogTitle>Choose Voice</DialogTitle></DialogHeader>
        <VoicePicker voice={draft} setVoice={setDraft} />
        <BarsLabelInput value={labelDraft} onChange={setLabelDraft} />
        <div className="flex justify-end pt-2">
          <button type="button" onClick={() => { onSave(draft); setBarsLabel(labelDraft); onOpenChange(false); }} data-testid="voice-save-btn"
            className="bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-[4px] px-8 py-2.5 transition-colors">Save</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
